import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  plannedOkrTotalizer: undefined,
  plannedOkrList: [],
  okrOverviewTotalizer: undefined,
  okrOverviewList: [],
  historicalPerformance: [],
  interviewEfficiencyByKey: {}
};

export default {
  state,
  actions,
  getters,
  mutations,
};
